var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-logo-container",class:{ collapse: _vm.collapse }},[_c('transition',{attrs:{"name":"sidebarLogoFade"}},[(!_vm.collapse)?_c('router-link',{key:"collapse",staticClass:"sidebar-logo-link",attrs:{"to":"/"}},[_c('img',{staticClass:"sidebar-logo",attrs:{"src":_vm.logo,"alt":"图片碎了"}})]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }